var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartData)?_c('pie-chart',{key:"gradeChart",attrs:{"chart-data":_vm.chartData,"tooltips-callback-cfg":_vm.tooltipsCallbackCfg,"legendCfg":{
    position: 'right'
  }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }